import { initializeApp } from 'firebase/app'
import {
	getAnalytics,
	setUserId,
	setUserProperties,
	logEvent,
} from 'firebase/analytics'
import {
	getRemoteConfig,
	fetchAndActivate,
	getValue as getRemoteConfigValue,
} from 'firebase/remote-config'
// import { getEnv } from '@/helperMethods'
import { createLogger } from './log'
import configDefaults from './firebaseDefaults.json'
import { getMyUser, getOrganization } from '@/store/memberships'

const log = createLogger('Firebase')

const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000

// TODO: find a way to reuse getEnv() here without a circular dependency
// const isProd = getEnv() === 'production'
const isProd =
	location.hostname.endsWith('pronto.io') &&
	!location.hostname.endsWith('dev.pronto.io')

const firebaseConfig = isProd
	? {
			apiKey: 'AIzaSyBu3lAkqfp3XwVgXoW00p_0bzuOVyC6-90',
			authDomain: 'hitlabs-pronto.firebaseapp.com',
			databaseURL: 'https://hitlabs-pronto.firebaseio.com',
			projectId: 'hitlabs-pronto',
			storageBucket: 'hitlabs-pronto.appspot.com',
			messagingSenderId: '584342142648',
			appId: '1:584342142648:web:f1cc4cc43d14a7a895be4d',
			measurementId: 'G-L1NEN7Z2H9',
	  }
	: {
			apiKey: 'AIzaSyBVVxoKgxrBryR2WpEBlrhpy-2EN5DsbNs',
			authDomain: 'hitlabs-pronto-dev.firebaseapp.com',
			databaseURL: 'https://hitlabs-pronto-dev.firebaseio.com',
			projectId: 'hitlabs-pronto-dev',
			storageBucket: 'hitlabs-pronto-dev.appspot.com',
			messagingSenderId: '55164021405',
			appId: '1:55164021405:web:3d452e4f21b7b3a8b84274',
			measurementId: 'G-14W5NESQFH',
	  }

const app = initializeApp(firebaseConfig)

const remoteConfig = getRemoteConfig(app)

remoteConfig.settings.minimumFetchIntervalMillis = isProd
	? TWELVE_HOURS_MS
	: 1000

remoteConfig.defaultConfig = configDefaults
let analytics = null

if (!window.Cypress) {
	analytics = getAnalytics(app)
	fetchAndActivate(remoteConfig)
		.then(() => {
			log('Firebase RemoteConfig', 'latest values fetched and activated')
		})
		.catch((e) => {
			console.error(e)
			log('Firebase RemoteConfig', 'ERROR', e?.message ?? e)
		})
}

export const getValue = (key) => {
	return getRemoteConfigValue(remoteConfig, key)
}

export const getLanguagesData = () => {
	const json = getValue('languages').asString()
	return json ? JSON.parse(json) : {}
}

export const getLiveCaptionsLangs = () => {
	const json = getValue('live_captions_langs').asString()
	return json ? JSON.parse(json) : {}
}

export const getTranslationLangs = () => {
	const json = getValue('translation_langs').asString()
	return json ? JSON.parse(json) : {}
}

export const identifyAnalyticsUser = () => {
	if (window.Cypress) return null
	const user = getMyUser()
	const org = getOrganization()
	if (!user?.id) return
	log('identifying analytics user', user.id, org?.id)
	setUserId(analytics, user.id)
	if (!org?.id) return
	setUserProperties(analytics, {
		org_id: org.id,
		org_name: org.name,
	})
}

export const trackAnalyticsEvent = (name, properties) => {
	logEvent(analytics, name, properties)
}
